import { getIbisModelList, getIbisPackageList } from '@/services/Sierra/library'
import { getSierraProjectPromise } from '@/services/Sierra';
import { getPins } from '@/services/Sierra/library/IbisModelHelper.js'
import { TX_MODEL_TYPES, RX_MODEL_TYPES } from '@/services/LibraryHelper'
import { getVerificationContentPromise, updateInterfacePromise } from '@/services/Sierra/SierraCtrl.js'
import { IC } from '../../PCBHelper';
import { userDefaultSettings } from '../../userDefaultSetting/userDefaultSettingCtrl';
import { SIGNAL_CLK, SIGNAL_DATA } from './tableHelper';
import { getOnlyOneClk } from '../interfaceData';
import { I2C, I3C, SPI_TYPES } from '../../PCBHelper/constants';

const AUTO_ASSIGN_MODEL = "autoAssignModel",
  ASSIGN_MODEL_TO_ALL_INTERFACES = "assignModelToAllInterfaces",
  APPLY_MODEL_TO_ALL_INTERFACES = "applyModelToAllInterfaces",
  APPLY_MODEL_TO_SETUP = "applyModelToSetup",
  APPLY_PKG = "applyPKG";

const PRBS_TYPES = ['PRBS-SDR', 'PRBS-DDR', 'PRBS-HDR'];
const CLK_TYPES = ["CLK+", "CLK-"];
const CLK_NAME_TYPES = ['CLK', 'SCK', 'SCLK', 'SCL'];

// function getUsage(type, prevUsage, ioBufferUsage) {
//   if (prevUsage === 'Driver') return INPUT.includes(type) ? 'Receiver' : prevUsage
//   if (prevUsage === 'Receiver') return ONLY_DRIVER_MODEL_TYPES.includes(type) ? 'Driver' : prevUsage;

//   if (IO.includes(type) && ["Driver", "Receiver"].includes(ioBufferUsage)) {
//     return ioBufferUsage;
//   }
//   return ONLY_DRIVER_MODEL_TYPES.includes(type) ? 'Driver' : 'Receiver'
// }

export function delay(time) {
  return new Promise((resolve) => {
    setTimeout(() => { resolve() }, time)
  })
}

function existEnableVoltage(type) {
  const _type = type.toUpperCase();
  if (_type.includes('I/O') || _type.includes('IO') || _type === 'TRISTATE' || _type === '3-STATE' || _type === '3STATE') {
    return true;
  };
  return false;
}

function removeIBISPkg(file, currentComp) {
  const pkg = currentComp.pkg;
  if (pkg && pkg.type === "IBIS" && pkg.libraryId !== file.libraryId) {
    currentComp.pkg = { type: 'None' }
  }
  return currentComp;
}

function autoAssignIBISPkg(prevFile, currentComp) {
  const pkg = currentComp.pkg
  let _pkg = { type: 'None' }
  let regenerate = false

  const newFile = (currentComp.model && currentComp.model.files && currentComp.model.files[0]) || {}

  if (prevFile && prevFile.libraryId === newFile.libraryId && pkg.type === 'IBIS' && newFile.component === prevFile.component) {
    return currentComp
  } else {
    regenerate = true
  }

  if (regenerate) {
    if ((pkg && (pkg.type === 'None' || pkg.type === 'IBIS' || pkg.type === '')) || !pkg) {
      const { component, libraryId } = newFile
      if (!component) {
        _pkg = { type: "None" }
      } else {
        _pkg = {
          type: 'IBIS',
          component: component,
          libraryId: libraryId,
          model: 'Pin',
          modelInfo: ''
        }
      }

      currentComp.pkg = { ..._pkg }
    }
  }

  return currentComp
}

function clearSinglePinInfo(current) {
  if (!current || (!current.driver && !current.receiver)) {
    return current;
  }
  if (current.driver) {
    current.driver.modelName = '';
    current.driver.modelType = '';
    current.driver.enableVoltage = '';
  }

  if (current.receiver) {
    current.receiver.modelName = '';
    current.receiver.modelType = '';
    current.receiver.enableVoltage = '';
  }
  current.powerOff = '0'

  return current
}

function getPinModels({ type, usage, deviceVcc = "" }) {
  let pinModels = getPins({ type, usage })

  if (pinModels.length > 0) {
    pinModels.forEach(item => {
      if (item.pinName === 'nd_pu') {
        item.voltage = deviceVcc ? parseFloat(deviceVcc) : ""
      }
      if (item.pinName === 'nd_pd') {
        item.voltage = "0"
      }
    })
  }

  return pinModels;
}

function isExistModelFiles(comp) {
  return comp.model && comp.model.files && comp.model.files.length && comp.model.files[0];
}

function getPinModelData({ pin, isMultiInterface }) {
  const key = isMultiInterface ? "model" : pin.usage === 'Driver' ? "driver" : "receiver";
  return pin[key] || {}
}

function getDefaultStimulusData({ pin, signalType, interfaceType }) {
  let { pinModels = [], signal } = pin;
  const type = signalType === "CLK" ? "CLK+" : signalType === "DATA" ? "PRBS-SDR" : "";
  if (!type) {
    return pinModels;
  }

  let newModelPins = JSON.parse(JSON.stringify(pinModels))
  let defaultDelayValue = ([...SPI_TYPES].includes(interfaceType) && CLK_NAME_TYPES.find(item => signal.includes(item)))
    || ([I2C, I3C].includes(interfaceType) && signalType === SIGNAL_CLK) ? { type: 'percent', value: '35' } : null;

  const pinName = "nd_in"
  let newType = type || "", newTaps = [], newDelay = "";
  if (PRBS_TYPES.includes(type)) {
    newType = `${type}-80`;
    newTaps = ['7', '6'];
  }

  const index = newModelPins.findIndex(item => item.pinName === pinName);
  if (index > -1) {
    newModelPins[index].type = newType || "";
    newModelPins[index].stimulus = "";
    if (PRBS_TYPES.includes(type)) {
      newModelPins[index].tabs = newTaps;
      delete newModelPins[index].delay;
      delete newModelPins[index].slew;
      newDelay = { type: 'percent', value: '10' };
      newModelPins[index].delay = { ...newDelay }
    }

    if (CLK_TYPES.includes(type)) {
      let defaultDelay = null;
      if (defaultDelayValue) {
        newModelPins[index].delay = defaultDelayValue
      } else {
        if ([I2C, I3C].includes(interfaceType)) {
          defaultDelay = { type: 'percent', value: '35' }
          newModelPins[index].delay = { ...defaultDelay }
        } else {
          newModelPins[index].delay = { type: 'percent', value: '10' };
        }
      }
      delete newModelPins[index].slew;
      delete newModelPins[index].dutyCycle;
      newDelay = defaultDelayValue ? defaultDelayValue : defaultDelay || { type: 'percent', value: '10' };
    }
  }

  // Delete stimulus
  const ndEn = newModelPins.findIndex(item => item.pinName === 'nd_en');
  if (ndEn > -1) {
    // Delete nd_en pin
    newModelPins.splice(ndEn, 1);
  }
  return newModelPins;
}

async function assignIBISModels({
  partModels = [],
  libraryId,
  currentComp,
  signals = [],
  allowClear,
  version,
  setSignals,
  getSignalUsage,
  setSignalUsage,
  getSignalType,
  setSignalType,
  masterComp = "",
  defaultBufferSpiceModel,
  handleType,
  isBidirectional,
  isMultiInterface,
  pcbId
}) {
  const models = (await getIbisModelList({ libraryId, usage: '' })) || {};
  const component = isExistModelFiles(currentComp) ? currentComp.model.files[0].component : "";
  const currentPkg = (models.packages || []).find(item => item.component === component)
  const pinSection = currentPkg && currentPkg.pinSection
  const selectorModels = models.selectorModels || [];

  let newCompModel = null;
  // find selector from packages and find modelsName from selectorModels
  const newPins = currentComp.pins.map((pin) => {
    const signalIndex = signals.findIndex(it => it.name === pin.signal);
    if (signalIndex < 0) {
      return pin;
    }
    const { name: signalName, isConnectMaster } = signals[signalIndex];

    if (!isConnectMaster && handleType === "changeMasterComp") {
      return pin;
    }

    let pinModelData = null;
    const [masterCompName, masterCompPcbId] = masterComp.split('::');
    let usage = !isConnectMaster ? pin.usage : masterCompName !== currentComp.name || pcbId !== masterCompPcbId || (getSignalUsage && getSignalUsage(pin.signal)) ? "Receiver" : "Driver";
    // 1. partModels -> find pin
    const partModel = partModels.find(it => it.pin === pin.pin);
    if (partModel && signalIndex > -1) {
      // 2. Locate the signal information corresponding to this pin and retrieve the masterComp
      const { signalType, speed, txModel, rxModel } = partModel;
      if (getSignalType && !getSignalType(signalName) && usage === "Driver") {
        setSignals(signalIndex, { type: signalType, clock: speed });
        if (setSignalType) {
          setSignalType(signalName, true);
        }
      }

      pin.usage = usage;
      if (usage === "Driver") {
        if (txModel && txModel.libraryId) {
          const deviceVcc = txModel.deviceVcc;
          delete txModel.deviceVcc;
          pinModelData = {
            ...txModel
          }
          const { modelType: type } = txModel;
          pin.powerOff = pin.powerOff ? pin.powerOff : '0';
          if (deviceVcc) {
            currentComp.deviceVcc = parseFloat(deviceVcc).toString();
          }
          pin.pinModels = handleType === "assignIBISModels" && pin.pinModels && pin.pinModels.length > 0 ? pin.pinModels : getPinModels({ type, usage, deviceVcc });
        }

        pin.speed = speed;
      } else if (usage === 'Receiver' && rxModel && rxModel.libraryId) {
        delete rxModel.deviceVcc;
        pinModelData = {
          ...rxModel
        }
      }

    } else {
      const pinInfo = pinSection && pinSection.find(_item => _item.pin === pin.pin)
      if (pinInfo) {
        const modelName = pinInfo.model_name;
        // match selector
        const selector = selectorModels.find(item => item.selector === modelName);

        let modelInfo, default_model
        if (!selector) {
          modelInfo = (models.models || []).find(item => item.name === modelName);
        } else {
          const select_models = selector.models;
          default_model = select_models[0] || {};
          modelInfo = (models.models || []).find(item => item.name === default_model.name);
        }

        //Terminator not support
        if (!modelInfo || modelInfo.type === "Terminator") {
          pin = clearSinglePinInfo(pin)
        } else {
          const { type, deviceVcc, name } = modelInfo;
          const { fileName } = currentComp.model.files[0];

          const default_pin_Model = {
            libType: 'IBIS',
            libraryId,
            fileName,
            modelType: type,
            modelName: name,
            enableVoltage: existEnableVoltage(type) ? (modelInfo.enable === 'NA' ? '1' : modelInfo.enable) : "",
            version: version || null,
          }

          // usage = getSignalUsage && getSignalUsage(pin.signal) && isConnectMaster ? "Receiver" : getUsage(type, pin.usage, ioBufferUsage);
          currentComp.deviceVcc = parseFloat(deviceVcc).toString();

          if (isMultiInterface) {
            pinModelData = { ...default_pin_Model }
          } else {

            if ((isBidirectional || usage === "Driver") && TX_MODEL_TYPES.includes(type)) {
              pinModelData = { ...default_pin_Model }
            }

            if ((isBidirectional || usage === "Receiver") && RX_MODEL_TYPES.includes(type)) {
              pinModelData = { ...default_pin_Model }
            }
          }
          pin.usage = usage;
          pin.powerOff = '0'
          pin.pinModels = handleType === "assignIBISModels" && pin.pinModels && pin.pinModels.length > 0 ? pin.pinModels : getPinModels({ type, usage, deviceVcc });
        }
      } else if (allowClear) {
        // current pin is not in current component, so we should clear this existing pin model info
        pin = clearSinglePinInfo(pin)
      }
    }

    pin.usage = getSignalUsage && getSignalUsage(pin.signal) && isConnectMaster ? "Receiver" : usage;
    if (setSignalUsage && pin.usage === 'Driver') {
      setSignalUsage(signalName, true);
    }

    if (pin.usage === 'Receiver' && (!pinModelData || !pinModelData.libraryId) && defaultBufferSpiceModel) {
      pinModelData = { ...defaultBufferSpiceModel };
    }

    if (pinModelData) {
      if (isMultiInterface) {
        pin.model = pinModelData;
      } else {
        if (isBidirectional || pin.usage === "Driver") {
          pin.driver = pinModelData;
        }
        if (isBidirectional || pin.usage === "Receiver") {
          pin.receiver = pinModelData;
        }
      }
    }

    const pinModel = getPinModelData({ pin, isMultiInterface });
    if (!newCompModel && pinModel.libraryId) {
      newCompModel = pinModel;
    }

    return pin;
  })

  currentComp.pins = newPins;
  if (newCompModel && newCompModel.libraryId) {
    currentComp.model = {
      files: [
        {
          fileName: newCompModel.fileName,
          component: newCompModel.component || "",
          libraryId: newCompModel.libraryId,
          type: newCompModel.libType,
          version: newCompModel.version
        }
      ],
      pairs: []
    };
  }
  return currentComp;
}

/**
 * @param {string} masterComp
 * @returns
 */
async function assignIBISModelsToComps({
  components,
  modelMap,
  isReplace = false,
  ioBufferUsage,
  signals,
  allowClear = true,
  masterComp,
  defaultBufferSpiceModel,
  handleType,
  pcbId
}) {
  // signalName -> isUseDriver
  const signalUsages = {};
  // signalName -> isSetSignalType
  const signalTypes = {};
  // signalName -> {type, speed}
  const changeSignals = {};
  try {
    for (let i = 0; i < components.length; i++) {
      let comp = components[i];
      if (!['Chip', 'IC'].includes(comp.type)) {
        continue;
      }
      if (!isReplace && isExistModelFiles(comp) && comp.model.files[0].libraryId) {
        continue;
      }

      const models = modelMap.get(comp.part) || [];
      const _model = models[0] || {};
      if (_model.libraryId) {
        components[i].model = {
          files: [
            {
              fileName: _model.file,
              component: _model.component,
              libraryId: _model.libraryId,
              type: "IBIS",
              version: _model.version
            }
          ],
          pairs: []
        };
      }

      components[i] = await assignIBISModels({
        partModels: models,
        libraryId: _model.libraryId,
        currentComp: components[i],
        signals,
        ioBufferUsage,
        allowClear,
        version: _model.version,
        masterComp,
        setSignals: (signalIndex, values) => {
          const currentSignal = signals[signalIndex];
          if (currentSignal.type === SIGNAL_CLK) {
            changeSignals[currentSignal.name] = { ...currentSignal, ...values };
            signals[signalIndex] = { ...currentSignal, ...values };
          } else if (values.type === SIGNAL_CLK) {
            const oldSignalIndex = signals.findIndex(it => it.type === SIGNAL_CLK);
            if (oldSignalIndex > -1) {
              delete signals[oldSignalIndex].clock;
              signals[oldSignalIndex] = { ...signals[oldSignalIndex], type: SIGNAL_DATA };
              changeSignals[signals[oldSignalIndex].name] = { ...signals[oldSignalIndex], type: SIGNAL_DATA };
            }
            changeSignals[currentSignal.name] = { ...currentSignal, ...values };
            signals[signalIndex] = { ...currentSignal, ...values };
          }
        },
        getSignalUsage: (signalName) => signalUsages[signalName],
        setSignalUsage: (signalName, value) => signalUsages[signalName] = value,
        getSignalType: (signalName) => signalTypes[signalName],
        setSignalType: (signalName, value) => signalTypes[signalName] = value,
        defaultBufferSpiceModel,
        handleType,
        pcbId
      })
    }
  } catch (error) {
    console.error(error)
  }
  return { components, changeSignals, signals };
}

function clearModels(currentComp) {
  const pins = currentComp.pins || []

  pins.forEach((item, index) => {
    currentComp.pins[index] = clearSinglePinInfo(item)
  })

  return currentComp
}

async function assignModelForInterfaces({ file, part, projectId, pcbId, updateAssignStatus, applyModelObj, verificationId }) {

  if (!projectId || !part || !file) return

  let current = 0
  const res = await getSierraProjectPromise(projectId)

  if (res === null) {
    updateAssignStatus({ finish: true, msg: 'Apply to all interfaces failed!' })
    await delay(2000)
    return
  }

  const userDefaultSetting = await userDefaultSettings.getSettings();
  const sierraSettings = userDefaultSetting && userDefaultSetting.sierraSettings ? userDefaultSetting.sierraSettings : null;
  const ioBufferUsage = sierraSettings && sierraSettings.ioBufferUsage ? sierraSettings.ioBufferUsage : null;

  let verifications = res.verifications
  const interfacesLength = res.verifications.length

  for (const verification of verifications) {
    if (verificationId === verification.id) {
      continue;
    }
    const res = await getVerificationContentPromise(verification.id)

    if (res === null) {
      updateAssignStatus({ finish: true, msg: 'Apply to all interfaces failed!' })
      await delay(2000)
      return
    }

    const Interfaces = res.Interfaces;
    const isBidirectional = res.isBidirectional;

    const { signals } = getConnectMasterSignalsData(Interfaces);
    for (const Interface of Interfaces) {
      if (Interface.pcbId !== pcbId) {
        continue;
      }
      let content = Interface.content
      if (!content || !content.components || !content.components.length) {
        continue;
      }
      const components = content.components

      let newComponents = []
      for (let comp of components) {
        const applyModel = applyModelObj[APPLY_MODEL_TO_ALL_INTERFACES];
        //apply model -> copy model to ic components
        //part -> copy and assign model to all same part components
        if (comp.type === IC && (applyModel || (applyModelObj[ASSIGN_MODEL_TO_ALL_INTERFACES] && comp.part === part))) {
          // files
          const prevFile = comp.model && comp.model.files && comp.model.files[0] ? comp.model.files[0] : null;
          //apply buffer model to all interfaces
          if (!comp.model) {
            comp.model = {}
          }
          comp.model.files = [file]
          // pkg: set ibis file to pkg model
          if (applyModelObj[APPLY_PKG]) {
            comp = autoAssignIBISPkg(prevFile, comp)
          } else {
            comp = removeIBISPkg(file, comp)
          }

          if (comp.part !== part || !applyModelObj[ASSIGN_MODEL_TO_ALL_INTERFACES]) {
            newComponents.push(comp)
            continue;
          }
          //copy and assign model to all same part components
          //auto assign all interfaces models(pin buffer model)
          comp = await assignIBISModels({
            libraryId: file.libraryId,
            currentComp: comp,
            signals,
            version: file.version,
            ioBufferUsage,
            isBidirectional,
            masterComp: content.masterComp,
            pcbId: Interface.designId || Interface.pcbId
          })
        }
        newComponents.push(comp)
      }

      content.components = newComponents

      // save
      const { pcbId: currPcbId, interfaceId, name: _name, readyForSim, designVersion, version, settingVersion } = Interface

      updateInterfacePromise({
        designId: currPcbId,
        interfaceId,
        interfaceName: _name,
        projectId,
        verificationId: verification.id,
        verificationName: verification.name,
        content,
        readyForSim,
        designVersion,
        version,
        settingVersion: settingVersion || ""
      })

      // update assign schedule status
      let status = ++current === interfacesLength ? { finish: true, msg: 'Already !' } : { finish: false, msg: `Currently Synchronizing ${_name}... ${current} / ${interfacesLength}` }
      updateAssignStatus(status)
    }
  }

  await delay(100)
  updateAssignStatus(null)
}

async function getComponentById(component, id) {
  const res = await getIbisPackageList(id)
  if (res && res.length > 0) {
    const components = res.map(item => item.component)
    component.model.files[0].component = components.length >= 1 ? components[0] : null
  }
  return component
}

async function applyModelToAllComponents({ file, Interfaces, applyModelObj, part, ioBufferUsage, isBidirectional }) {
  const { signals } = getConnectMasterSignalsData(Interfaces);
  for (const Interface of Interfaces) {
    let content = Interface.content
    if (!content || !content.components || !content.components.length) {
      continue;
    }
    const components = content.components

    let newComponents = []
    for (let comp of components) {
      //apply model -> copy model to ic components
      //part -> copy and assign model to all same part components
      if (comp.type === IC) {
        // files
        const prevFile = comp.model && comp.model.files && comp.model.files[0] ? comp.model.files[0] : null;
        //apply buffer model to all interfaces
        if (!comp.model) {
          comp.model = {}
        }
        comp.model.files = [file]
        // pkg: set ibis file to pkg model
        if (applyModelObj[APPLY_PKG] && file.component) {
          comp = autoAssignIBISPkg(prevFile, comp)
        } else {
          comp = removeIBISPkg(file, comp)
        }

        //copy and assign model to all same part components
        //auto assign all current setup interfaces models(pin buffer model)
        if (file.component &&
          (applyModelObj[ASSIGN_MODEL_TO_ALL_INTERFACES] || applyModelObj[AUTO_ASSIGN_MODEL])
          && comp.part === part) {
          comp = await assignIBISModels({
            libraryId: file.libraryId,
            currentComp: comp,
            version: file.version,
            ioBufferUsage,
            isBidirectional,
            signals,
            masterComp: content.masterComp,
            pcbId: Interface.designId || Interface.pcbId
          })
        }
      }
      newComponents.push(comp)
    }
    Interface.content.components = newComponents
  }
  return Interfaces;
}

// change： { model, usage, speed, powerOff, pinModels, enableVoltage, deviceVcc }
async function getAssignBufferModelByPin({ pin, model, usage, partModels, currentComp, isMultiInterface, isBidirectional }) {
  let isAssign = null, pinModelData = null;
  // 1. partModels -> find pin
  const partModel = partModels.find(it => it.pin === pin.pin);
  if (partModel) {
    const { speed, txModel, rxModel } = partModel;
    pin.usage = usage;
    if (usage === "Driver" && txModel && txModel.libraryId) {
      const deviceVcc = txModel.deviceVcc;
      delete txModel.deviceVcc;
      pinModelData = {
        ...txModel
      }

      pin.speed = speed;
      const { modelType: type } = txModel;
      pin.powerOff = '0'
      currentComp.deviceVcc = parseFloat(deviceVcc).toString();
      pin.pinModels = getPinModels({ type, usage, deviceVcc });
      isAssign = true;
    } else if (usage === 'Receiver' && rxModel && rxModel.libraryId) {
      delete rxModel.deviceVcc;
      pinModelData = {
        ...rxModel
      }
      pin.speed = "";
      isAssign = true;
    }
  } else {
    // 2. get ibis model
    const models = (await getIbisModelList({ libraryId: model.libraryId, usage: '' })) || {};
    const component = isExistModelFiles(currentComp) ? currentComp.model.files[0].component : "";
    const currentPkg = (models.packages || []).find(item => item.component === component)
    const pinSection = currentPkg && currentPkg.pinSection
    const selectorModels = models.selectorModels || [];
    const pinInfo = pinSection && pinSection.find(_item => _item.pin === pin.pin)
    if (pinInfo) {
      const modelName = pinInfo.model_name
      // match selector
      const selector = selectorModels.find(item => item.selector === modelName)

      let modelInfo, default_model
      if (!selector) {
        modelInfo = (models.models || []).find(item => item.name === modelName)
      } else {
        const select_models = selector.models
        default_model = select_models[0] || {}
        modelInfo = (models.models || []).find(item => item.name === default_model.name)
      }

      const { type, deviceVcc, name, version } = modelInfo
      const { fileName } = currentComp.model.files[0];

      const default_pin_Model = {
        libType: 'IBIS',
        libraryId: model.libraryId,
        fileName,
        modelType: type,
        modelName: name,
        enableVoltage: existEnableVoltage(type) ? (modelInfo.enable === 'NA' ? '1' : modelInfo.enable) : "",
        version: version || null,
      }

      if (isMultiInterface) {
        pin.model = { ...default_pin_Model }
      } else {

        if ((isBidirectional || usage === "Driver") && TX_MODEL_TYPES.includes(type)) {
          pin.driver = { ...default_pin_Model }
        }

        if ((isBidirectional || usage === "Receiver") && RX_MODEL_TYPES.includes(type)) {
          pin.receiver = { ...default_pin_Model }
        }
      }
      currentComp.deviceVcc = parseFloat(deviceVcc).toString();
      pin.usage = usage;
      pin.powerOff = '0'
      pin.pinModels = getPinModels({ type, usage, deviceVcc });
      isAssign = true;
    }
  }

  if (pinModelData) {
    if (isMultiInterface) {
      pin.model = pinModelData;
    } else {
      if (isBidirectional || pin.usage === "Driver") {
        pin.driver = pinModelData;
      }
      if (isBidirectional || pin.usage === "Receiver") {
        pin.receiver = pinModelData;
      }
    }
  }
  return { isAssign, pin, currentComp };
}

// after assign buffer model, Synchronize the "speed" attribute in the "pin".
function checkSignalAndPin({ interfaceParams = [], allChangeSignals, handleType, interfaceType, masterConnectSignals }) {
  const signals = interfaceParams[0].content.signals.map(signal => {
    const signalName = signal.name;
    if (allChangeSignals[signalName] && allChangeSignals[signalName].type) {
      signal.type = allChangeSignals[signalName].type;
    }
    return signal;
  });
  const changeSignals = Object.values(allChangeSignals);
  const isGroup = changeSignals.find(it => !!it.signalGroup);
  const isOnlyOneClk = getOnlyOneClk(signals);
  const signalGroupSpeed = {};
  if (isGroup) {
    const signalGroups = ([...new Set(Object.values(allChangeSignals).map(it => it.signalGroup))]);
    for (const group of signalGroups) {
      const speed = (changeSignals.find(it => it.type === SIGNAL_CLK && it.signalGroup === group && it.clock) || {}).clock || "";
      signalGroupSpeed[group] = speed;
    }
  } else if (isOnlyOneClk) {
    const speed = (changeSignals.find(it => it.type === SIGNAL_CLK) || {}).clock || "";
    signalGroupSpeed.default = speed;
  }

  for (const _interface of interfaceParams || []) {
    // check signal
    _interface.content.signals = _interface.content.signals.map(item => {
      const signalName = item.name;
      const changeSignalInfo = allChangeSignals[signalName];
      if (changeSignalInfo && changeSignalInfo.type) {
        item.type = changeSignalInfo.type;
      }

      if (changeSignalInfo && item.type) {
        const speed = signalGroupSpeed[item.signalGroup] || signalGroupSpeed.default || "";
        item.clock = speed;
      }
      return item;
    })
    // check pin speed
    _interface.content.components = _interface.content.components.map(comp => {
      comp.pins = comp.pins.map(pin => {
        const signalInfo = _interface.content.signals.find(it => it.name === pin.signal) || {};
        const { signalGroup, type: signalType } = signalInfo;
        if (pin.usage === "Driver" && pin.signal) {
          const speed = signalGroupSpeed[signalGroup] || signalGroupSpeed.default || "";
          pin.speed = speed;
          pin.pinModels = getDefaultStimulusData({ pin, signalType, interfaceType });
        }
        return pin;
      })
      return comp;
    })
    if (handleType !== 'changeMasterComp') {
      // judge delete master comp
      const isDeleteMasterComp = _interface.content.signals.find(it => !masterConnectSignals.includes(it.name));
      if (isDeleteMasterComp) {
        _interface.content.masterComp = "";
      }
    }
  }

  return interfaceParams;
}

function getConnectMasterSignalsData(interfaceParams) {
  if (!interfaceParams || !interfaceParams.length) {
    return { signals: [], masterConnectSignalNames: [] }
  }
  const masterComp = interfaceParams[0].content.masterComp || "";
  const [masterCompName, masterCompPcbId] = masterComp.split('::');
  const masterInterface = !masterCompPcbId ? interfaceParams[0]
    : interfaceParams.find(_interface => _interface.designId === masterCompPcbId || _interface.pcbId === masterCompPcbId);
  if (!masterInterface) {
    return { signals: [], masterConnectSignalNames: [] }
  }
  const compInfo = !masterCompPcbId || masterCompPcbId === masterInterface.designId || masterCompPcbId === masterInterface.pcbId
    ? masterInterface.content.components.find(item => item.name === masterCompName) || {}
    : {};
  const pins = compInfo.pins || [];
  const signalNames = pins.map(item => item.signal);

  let masterConnectSignals = [];
  if (Object.keys(compInfo).length > 0) {
    masterConnectSignals = [...signalNames];
  }
  const signals = JSON.parse(JSON.stringify(masterInterface.content.signals)).map(item => {
    if (signalNames.includes(item.name)) {
      return { ...item, isConnectMaster: true }
    }
    return item;
  })

  return { signals, masterConnectSignals }
}

export {
  assignIBISModels,
  autoAssignIBISPkg,
  clearModels,
  assignModelForInterfaces,
  getComponentById,
  AUTO_ASSIGN_MODEL,
  ASSIGN_MODEL_TO_ALL_INTERFACES,
  APPLY_MODEL_TO_ALL_INTERFACES,
  APPLY_MODEL_TO_SETUP,
  APPLY_PKG,
  applyModelToAllComponents,
  assignIBISModelsToComps,
  getAssignBufferModelByPin,
  checkSignalAndPin,
  getConnectMasterSignalsData,
  getDefaultStimulusData
}